import student from './student';
import teacher from './teacher';
import student2 from './student2';
import student3 from './student3';
export default {
    student,
    teacher,
    student2,
    student3
}